import { render, staticRenderFns } from "./expenseList.vue?vue&type=template&id=04969bae&"
import script from "./expenseList.vue?vue&type=script&lang=js&"
export * from "./expenseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports